'use strict';

import { forEach } from 'lodash';
import 'jquery-validation';

import { subscribe } from '../../01-helpers/event-manager';
import { CARD_ADDED } from '../../02-const/event-names';

import ValidationForm from '../../04-components/validation/validate-form';

/* ========================================================================== */

const moduleName = 'validate-form',
	selectors = {
		base: `.js-${moduleName}`,
		submit: `.js-${moduleName}-submit`,
		fields: `.js-${moduleName}-fields`,
		checks: `.js-${moduleName}-checkbox`,
	};

/* ========================================================================== */

class TeetimeValidation extends ValidationForm {
	constructor(baseElement) {
		super(baseElement);

		// if new input is added to form re-check if submit needs to be disabled
		subscribe(CARD_ADDED, this._onChangeHandler.bind(this));
	}

	_configure() {
		$(this.baseElement).validate({
			errorPlacement: function (error, element) {
				error.insertBefore(element);
			},
			// use highlight and unhighlight
			highlight: function (element) {
			},
			unhighlight: function (element) {
			}
		});
	}

	/* ------------------------------------------------------------------------- */

	_onChangeHandler() {
		this.fields = this.baseElement.querySelectorAll(selectors.fields);
		this.checks = this.baseElement.querySelectorAll(selectors.checks);
		// check if all required fields are filled
		let values = [];
		forEach(this.fields, (field) => values.push(field.value));
		forEach(this.checks, (check) => values.push(check.checked));
		// if so enable the submit button
		this.submitButton.disabled = values.includes('') || values.includes(false);
	}
}

export { TeetimeValidation as TeetimeValidation };